export default __webpack_public_path__ + "static/media/labs_with_person.a28aebcc.svg";